import React, { createContext, useState } from "react";

export const IsDisabledContext = createContext(); 

export const IsDisabledProvider = ({ children }) => {
  const [isDisabled, setIsDisabled] = useState(false)

  return (
    <IsDisabledContext.Provider value={{ isDisabled, setIsDisabled }}>
      {children} 
    </IsDisabledContext.Provider>
  );
};
